import React, { Component } from 'react';
import { Button, Paper, TextField, Grid, Modal } from '@material-ui/core';
import PropTypes from 'prop-types';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import i18n from '../../i18n';

import '../../assets/stylesheets/Setting.css';

const initialState = (date) => ({
  projectName: '',
  notes: '',
  startDate: date,
  endDate: date,
  error: false
});

class AddSpecialProjectModal extends Component {
  constructor(props) {
    super(props);

    this.state = initialState(new Date());
  }

  handleChange = event => {
    const {
      target: { name, value }
    } = event;

    const error = value === '';

    this.setState({
      [name]: value,
      error
    });
  };

  changeStartDate = startDate => {
    this.setState({ startDate });
  };

  changeEndDate = endDate => {
    this.setState({ endDate });
  };

  handleAdd = () => {
    const { addSpecialProject } = this.props;
    const { projectName, notes, startDate, endDate } = this.state;
    addSpecialProject(projectName, notes, startDate, endDate);
  };

  onClose = () => {
    const { toggleAddModal } = this.props;
    this.setState(initialState(new Date()), () => toggleAddModal());
  };

  render() {
    const { showAddModal } = this.props;
    const { projectName, startDate, endDate, error } = this.state;
    return (
      <Modal open={showAddModal} onClose={this.onClose}>
        <Paper className="deleteModal">
          <div>
            <Grid container>
              <Grid item xs={12}>
                {i18n.t('specialProject:enterProjectInfo')}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  error={error}
                  id="projectName"
                  label={i18n.t('specialProject:projectName')}
                  name="projectName"
                  autoFocus
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  multiline
                  rows="6"
                  error={error}
                  id="notes"
                  label={i18n.t('specialProject:notes')}
                  name="notes"
                  autoFocus
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={2}>
                {i18n.t('specialProject:startDate')}
              </Grid>
              <Grid item xs={4}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  className="bookingSelectField"
                >
                  <DatePicker
                    value={startDate}
                    onChange={this.changeStartDate}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={2}>
                {i18n.t('specialProject:endDate')}
              </Grid>
              <Grid item xs={4}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  className="bookingSelectField"
                >
                  <DatePicker value={endDate} onChange={this.changeEndDate} />
                </MuiPickersUtilsProvider>
              </Grid>
              <br />
              <br />
              <br />
              <Grid item xs={6}>
                <Button
                  onClick={this.handleAdd}
                  className="ssenseButton ssensePrimary"
                  disabled={error || projectName === ''}
                >
                  {i18n.t('confirm')}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={this.onClose}
                  className="ssenseButton ssenseDefault"
                >
                  {i18n.t('cancel')}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Modal>
    );
  }
}

AddSpecialProjectModal.propTypes = {
  showAddModal: PropTypes.bool.isRequired,
  toggleAddModal: PropTypes.func.isRequired,
  addSpecialProject: PropTypes.func.isRequired
};

export default AddSpecialProjectModal;
